//no-unused-vars
import React, {Component} from 'react';
import AbstractFormat from "./HyperComplexSem_2021-08-26.zip";
import ApplicationFormPDF from "./Conference_Announcement.pdf";
//import ApplicationFormODT from "./Conference_Announcement.odt";
import ApplicationFormODT from "./Application_form2.odt";
import LogoZosia from "./logoApki2.png";
import TemplateFormPDF from "./HyperComplexSem_template.pdf";
import TemplateFormTEX from "./HyperComplexSem_template.tex";



export const PublicationsPage = () => (
  <div className='container'>
		<h2>Publications and submissions</h2><br/>
		<p>All submissions will be reviewed by our prestigious international review committee with a preference towards (Hyper)Complex Analysis in Differential Equations Geometry and Physical Applications including also applications-focused work with physics, electronics, informatics, mechanics and materials science relevance.</p>
		
		<h3>Talk and Poster Session</h3>
<p>Participants willing to give a <b>talk</b> are requested to send <b>application</b> and <b>abstract</b> both in tex and pdf form.<br/> 
Participants willing to take part in the Poster Session are requested to send application,  abstract or  article for display, both in tex and pdf form.
Participants willing to be listeners only are requested to send an application form.
You can download the relevant style files here: Application <a href={ApplicationFormODT} target="_blank">form</a>, Abstract <a href={TemplateFormTEX} target="_blank">TEX</a>, Abstract <a href={TemplateFormPDF} target="_blank">PDF</a>.
Please submit the files to hypercomplexseminar@gmail.com . The deadline for the submission is 1<sup>st</sup> July, 2023.<br/><br/></p>

<h3>Article publication</h3>
<div className='container-fluid' >
	<div class="row">
		<div class="col-md-6">
			<p>All participants willing to publish an article in <br/>
<a href="http://czasopisma.ltn.lodz.pl/index.php/Bulletin/scope">	
(HYPER)COMPLEX SEMINAR 2023 IN MEMORIAM OF PROF. JULIAN LAWRYNOWICZ. A monograph
</a><br/>
are expected to submit a proposed article by 1<sup>st</sup> November, 2023.<br/>

Organizers are planning to publish all accepted articles in online version.<br/>
The style files for article for the monograph are here:  Article TEX file, Article PDF file.<br/>
Accepted authors must register for the conference.<br/><br/>
If you wish to use other possibilities of publication, we recommend Mathematics and Computers in Simulation.<br/>
</p>
		</div>
		<div class="col-md-6">
		<a href="http://czasopisma.ltn.lodz.pl/index.php/Bulletin/scope"><img src="http://czasopisma.ltn.lodz.pl/public/journals/7/cover_issue_151_pl_PL.png"
			 alt={'Bullet In de la Societe des Sciences et des Lettres de Lodz, src. ltn.lodz.pl'} height="170"/></a>
		</div>
	</div>
</div>


	
	<h3>We have future!</h3>
	<p>We present the graphics of our conference as seen with the eyes of a young, 9 years old Zosia Zubert, maybe our future Participant?<br/><br/>
	<center><img src={LogoZosia} alt={'Zosia\'s graphics'} width="386"/></center>
	</p>
	</div>	
);
 
//export default ProgrammePage
